import api from '../../../api/consultations/_protocole-soins'

const state = () => ({
    consultation_protocoles_soins: [],
    traitement_en_cours: [],
    protocole_plaintes: [],
    protocole_evenements: []
})

// getters
const getters = {
    consultation_protocoles_soins: (state) => {
        return state.consultation_protocoles_soins
    },

    traitement_en_cours: (state) => {
        return state.traitement_en_cours
    },

    protocole_plaintes: (state) => {
        return state.protocole_plaintes
    },

    protocole_evenements: (state) => {
        return state.protocole_evenements
    },
}

// mutations
const mutations = {
    SET_CONSULTATION_PROTOCOLES_SOINS(state, liste) {
        state.consultation_protocoles_soins = liste
    },

    SET_TRAITEMENT_EN_COURS(state, liste) {
        state.traitement_en_cours = liste
    },

    SET_PROTOCOLE_PLAINTES(state, liste) {
        state.protocole_plaintes = liste
    },

    SET_PROTOCOLE_EVENEMENTS(state, liste) {
        state.protocole_evenements = liste
    },
}

// actions
const actions = {
    saveConsultationProtocoleSoins({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationProtocoleSoins(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsultationProtocoleSoins({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getConsultationProtocoleSoins(data).then(
                response => {
                    commit('SET_CONSULTATION_PROTOCOLES_SOINS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveConsultationCatConsigne({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveConsultationCatConsigne(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteConsultationCatConsigne({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteConsultationCatConsigne(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteProtocoleSoins({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteProtocoleSoins(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTraitementEnCours({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getTraitementEnCours(data).then(
                response => {
                    commit('SET_TRAITEMENT_EN_COURS', response)
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveProcessStatus({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveProcessStatus(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getProtocoleData({commit}, data) {
        return new Promise((resolve, reject) => {
            api.getProtocoleData(data).then(
                response => {
                    if (data.data_type == 'plainte') {
                        commit('SET_PROTOCOLE_PLAINTES', response)
                    } else if (data.data_type == 'evenement') {
                        commit('SET_PROTOCOLE_EVENEMENTS', response)
                    }
                    
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    saveProtocoleData({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.saveProtocoleData(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    deleteProtocoleData({dispatch}, data) {
        return new Promise((resolve, reject) => {
            api.deleteProtocoleData(data).then(
                response => {
                    dispatch
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}